import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { UserRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';
import { IPlan } from '@leedpulse-monorepo/interfaces';

async function syncPlanWithStripe(
  planDoc: IPlan,
  auth: Authentication
): Promise<IPlan | null> {
  try {
    if (
      ![UserRole.owner, UserRole.admin, UserRole.maintainer].includes(auth.role)
    ) {
      throw new SyncPlanFailure('Unauthorized', 'unauthorized');
    }
    const result = await HttpClient.get(`/${planDoc.product}/stripe/backoffice/sync-plan/${planDoc.id}`, auth.token);

    if (result.success) {
      return result.data ?? null;
    } else {
      throw new SyncPlanFailure(result?.data?.error ?? 'Unknown error', 'unknown-error');
    }
  } catch (e) {
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new SyncPlanFailure('Le serveur ne répond pas');
    } else {
      throw new SyncPlanFailure(`Erreur lors de la résyncronisation du plan : ${e instanceof Error ? e.message : String(e)}`, "400");
    }
  }
}

export class SyncPlanFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default syncPlanWithStripe;
